export const CANDIDATES = 'Candidates';
export const ALL_CANDIDATES = 'All Candidates';
export const MERGE_PROFILES_TITLE = 'Merge profiles';
export const CANDIDATE_NOTES_STATE_IS_LOADING =
  'CANDIDATE_NOTES_STATE_IS_LOADING';
export const REFERRALS = 'Referrals';
// Candidate statuses

export const ACCEPTDECLINE = 'AD';
export const ACTIVE = 'A';
export const OTHER_REASON_CODE = 'Other';
export const REASSIGNED = 'RA';
